import React, { useState, useEffect } from 'react';
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { desc } from '../jsonfiles/galleryDesc';
import '../styles/gallery.css';
import loaderImg from '../imagProps/events5/favicon.ico'; // Path to your loader image


/* Gallery page and modal when clicked */

function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(null);
  const [imagesLoaded, setImagesLoaded] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const totalImages = desc.length;

  const handleImageLoad = () => {
    setImagesLoaded((prev) => prev + 1);
  };


  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = ''; // Clean up on unmount
    };
  }, [isLoading]);

  useEffect(() => {
    if (imagesLoaded === totalImages) {
      setTimeout(() => setIsLoading(false), 500); // slight delay for smooth transition
    }
  }, [imagesLoaded, totalImages]);

  const openModal = (index) => setCurrentIndex(index);
  const closeModal = () => setCurrentIndex(null);
  const findPrev = () => currentIndex > 0 && setCurrentIndex(currentIndex - 1);
  const findNext = () => currentIndex < desc.length - 1 && setCurrentIndex(currentIndex + 1);

  useEffect(() => {
    document.body.classList.toggle('modal-open', currentIndex !== null);
    return () => document.body.classList.remove('modal-open');
  }, [currentIndex]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.keyCode === 27) closeModal();
      if (e.keyCode === 37) findPrev();
      if (e.keyCode === 39) findNext();
    };
    document.body.addEventListener('keydown', handleKeyDown);
    return () => document.body.removeEventListener('keydown', handleKeyDown);
  }, [currentIndex]);



  return (
    <div className="gallery-container">
      {isLoading && (
        <div className="loader-overlay">
          <img src={loaderImg} alt="Loading..." className="loader-image" loading="lazy" decoding="async" />

          {/* Loading text below the image */}
          <p className="loading-text">Images loading, please wait...</p>

          {/* Optional loading bar */}
          <div className="loading-bar">
            <div className="loading-bar-progress"></div>
          </div>
        </div>
      )}

      <div className="gallery-grid">
        <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 550: 2, 900: 4 }}>
          <Masonry gutter='10px'>
            {desc.map((image, idx) => (
              <div key={image.imgPath} onClick={() => openModal(idx)}>
                <div className="image-wrapper">
                  <img
                    src={require(`../imagProps/events5/${image.imgPath}`)}
                    alt={image.desc}
                    onLoad={handleImageLoad}
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="hover-text"><p>{image.desc}</p></div>
                </div>
              </div>
            ))}
          </Masonry>
        </ResponsiveMasonry>
      </div>
      {currentIndex !== null && (
        <GalleryModal
          closeModal={closeModal}
          findPrev={findPrev}
          findNext={findNext}
          hasPrev={currentIndex > 0}
          hasNext={currentIndex < desc.length - 1}
          src={desc[currentIndex].imgPath}
          alt={desc[currentIndex].desc}
        />
      )}
    </div>
  );
}

function GalleryModal({
  closeModal,
  hasPrev,
  hasNext,
  findPrev,
  findNext,
  src,
  alt,
}) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.keyCode === 27) closeModal();
      if (e.keyCode === 37 && hasPrev) findPrev();
      if (e.keyCode === 39 && hasNext) findNext();
    };
    document.body.addEventListener('keydown', handleKeyDown);
    return () => document.body.removeEventListener('keydown', handleKeyDown);
  }, [closeModal, hasPrev, hasNext, findPrev, findNext]);

  if (!src) return null;

  return (
    <div>
      <div className="modal-overlay" onClick={closeModal}></div>
      <div className="modal">
        <div className="modal-body">
          <a href="#" className="modal-close" onClick={closeModal}>&times;</a>
          {hasPrev && <a href="#" className="modal-prev" onClick={findPrev}>&lsaquo;</a>}
          {hasNext && <a href="#" className="modal-next" onClick={findNext}>&rsaquo;</a>}
          <div className="modal-content">
            <img src={require(`../imagProps/events5/${src}`)} alt={alt} loading="lazy" decoding="async" />
            <p className="image-description">{alt}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Gallery;
